import type { GroomingItem, Profile, RitualSnapshot, WardrobeItem } from "../types";
import { isoNow, localDateKey, userTimeZone } from "./date";
import { defaultSchedule, defaultWindow } from "./schedule";

export function defaultProfile(now = isoNow()): Profile {
  return {
    id: "local",
    display_name: "",
    timezone: userTimeZone(),
    created_at: now,
    updated_at: now,
  };
}

export function defaultGroomingItems(now = isoNow()): GroomingItem[] {
  const today = localDateKey(new Date());
  return [
    { id: "g1", name: "Shampoo", interval_days: 3, last_done: null, schedule: defaultSchedule("interval", today, { interval_days: 3, windows: [defaultWindow("Morning", "08:00", "10:00")] }) },
    { id: "g2", name: "Moisturizer", interval_days: 1, last_done: null, schedule: defaultSchedule("daily", today, { windows: [defaultWindow("Morning", "08:00", "10:00"), { ...defaultWindow("Night", "21:00", "22:30"), id: "night" }] }) },
    { id: "g3", name: "Face Wash", interval_days: 1, last_done: null, schedule: defaultSchedule("daily", today, { windows: [defaultWindow("Morning", "07:00", "09:00"), { ...defaultWindow("Night", "21:00", "22:30"), id: "night" }] }) },
    { id: "g4", name: "Trimming / Shaving", interval_days: 7, last_done: null, schedule: defaultSchedule("interval", today, { interval_days: 7, windows: [defaultWindow("Morning", "08:00", "11:00")] }) },
    { id: "g5", name: "Nail Clipping", interval_days: 10, last_done: null, schedule: defaultSchedule("interval", today, { interval_days: 10, windows: [defaultWindow("Evening", "18:00", "21:00")] }) },
  ].map((item) => ({
    ...item,
    user_id: null,
    created_at: now,
    updated_at: now,
    deleted_at: null,
  }));
}

export function defaultWardrobeItems(now = isoNow()): WardrobeItem[] {
  const today = localDateKey(new Date());
  const base = [
    { id: "w1", name: "White linen shirt", category: "Tops", color: "White", notes: "Sample: easy work / casual base.", image_url: "/wardrobe/white-linen-shirt.png" },
    { id: "w2", name: "Black crew neck tee", category: "Tops", color: "Black", notes: "Sample: default casual top.", image_url: "/wardrobe/black-crew-tee.png" },
    { id: "w3", name: "Blue denim jeans", category: "Bottoms", color: "Blue", notes: "Sample: pairs with most tops.", image_url: "/wardrobe/blue-denim-jeans.png" },
    { id: "w4", name: "Charcoal chinos", category: "Bottoms", color: "Charcoal", notes: "Sample: office-friendly fallback.", image_url: "/wardrobe/charcoal-chinos.png" },
    { id: "w5", name: "Navy overshirt", category: "Outerwear", color: "Navy", notes: "Sample: light layer for evenings.", image_url: "/wardrobe/navy-overshirt.png" },
  ];

  return base.map((item) => ({
    ...item,
    user_id: null,
    created_at: now,
    updated_at: now,
    deleted_at: null,
    last_worn: null,
    added_on: today,
    schedule: defaultSchedule("weekly", today, {
      weekdays: [new Date().getDay()],
      windows: [defaultWindow("Wear", "08:00", "11:00")],
    }),
  }));
}

export function emptySnapshot(now = isoNow()): RitualSnapshot {
  return {
    profile: defaultProfile(now),
    nutrition: [],
    grooming: defaultGroomingItems(now),
    wardrobe: defaultWardrobeItems(now),
    learning: [],
    logs: [],
    last_synced_at: null,
  };
}

export function defaultWardrobeAddedOn(timezone?: string) {
  return localDateKey(new Date(), timezone);
}
